<template>
    <b-card style="position: relative;" class="mb-0">
    <b-row class="mb-2">
      <b-col :cols="6">
           <b-input-group
            label="Filter"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
            :width="enableSort ? '180px' : '320px'">
            <b-form-input v-model="search" placeholder="Type to search table"/>
            <b-input-group-append>
              <b-button :disabled="!search" @click="search = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        <div style="margin-top: 20px; font-weight: bold; color: #39AAFF; text-transform: uppercase">{{ description }}</div>
      </b-col>
      <b-col :cols="1"></b-col>
      <b-col :cols="2" class="text-right">
        <list-control :label="`${columns.length} columns`" width="100%">
          <b-dropdown text="Active columns">
            <div
              v-for="col in allColumns"
              :key="col"
              class="dropdown-item text-body">
              <b-form-checkbox
                v-model="columns"
                name="columns"
                :value="col">
                {{ titleCase(col) }}
              </b-form-checkbox>
            </div>
          </b-dropdown>

        </list-control>
      </b-col>
      <b-col :cols="2" style="margin-top: 27px">
        <b-button @click="actAll()">Email Data</b-button>
      </b-col>
    </b-row>
        <!-- <list-control :label="`${columns.length} columns`" width="100%">
          <b-dropdown text="Active columns">
            <div
              v-for="col in fields"
              :key="col.key"
              class="dropdown-item text-body">
              <b-form-checkbox
                v-model="columns"
                name="columns"
                :value="col.key">
                {{ col.key }}
              </b-form-checkbox>
            </div>
          </b-dropdown>
        </list-control> -->


  <div style="overflow-x: auto;">
      <b-table
        small
        striped
        hover
        head-variant="dark"
        :filter="search"
        @filtered="onFiltered"

        :items="values"
        :current-page="currentPage"
        :per-page="perPage"
        :fields="[{key: '#'}, ...tableFields]">
        <template v-slot:cell(#)="data">
<!--          {{ data.index + 1 }}-->
          {{ (((currentPage)?currentPage-1:0) * ((rowsPerPage)?rowsPerPage:20)) + data.index + 1}}
<!--          {{ (1 * this.perPage) + data.index + 1 }}-->
        </template>
        <template v-slot:cell()="data">
          <template v-if="checkArrayContainsObject(data.value)">
             {{data.value.length}} rows
            <b-button
             variant="link"
             @click="open_table(data)">View details</b-button>

          </template>
          <template v-else-if="checkArrayContainsIDs(data.value)">
            {{data.value.length}} rows
            <b-button
              variant="link"
              @click="open_table(data)">
                    View details
            </b-button>

          </template>
          <template v-else-if="isObject(data.value)">
             {{[data.value].length}} rows
            <b-button
              variant="link"
              @click="open_table(data)">
                    View details
            </b-button>

          </template>
          <template v-else>
            {{data.value}}
          </template>
        </template>

      <template v-slot:cell(__action)="data">
          <div class="text-right">
            <b-button
              v-if="enableAction"
              variant="outline-primary"
              size="sm"
              @click="act(data.item)">
              <i class="fa fa-envelope"/>
              <span class="ml-1" v-if="actionText">

              </span>
            </b-button>
          </div>
        </template>
        <template v-slot:empty="scope">
          <div class="my-5 py-5 text-center">
            <h6 v-if="items">{{ scope.emptyText }}</h6>
            <i v-else class="fa fa-spinner fa-spin fa-2x"/>
          </div>
        </template>
      </b-table>
    </div>

    <b-row v-if="totalRows" class="pt-2" @sort-changed="sortingChanged"
        style="vertical-align: top; border-top: 1px solid lightgrey;">
        <b-col :cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
      </b-row>
    <div v-if="data_gotten != null">
        <nested-table
          :nested_data="data_gotten"
          :_key="table_key"
          :table_name="table_name"
          @close="data_gotten = null"/>
    </div>

   <div v-if="isLoadingPage || this.totalRows <= 0"
         style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;
         background: rgba(255, 255, 255, .3); border-radius: 5px;">
      <align-middle>
        <div class="text-center">
          <strong class="fa fa-3x fa-spin fa-spinner"/>
        </div>
      </align-middle>
    </div>
  </b-card>
</template>

<script>
  import {titleCase} from '../Insights/utils';
  import InsightsComputationMixin from '../Insights/InsightsComputationMixin';
  import ListControl from '../Insights/ListControl';
  import {getCookie, setCookie} from '../../utils';
  import {maybeMissingValueLabel} from '../Insights/utils';
  import AlignMiddle from '../Sources/AlignMiddle';
  import NestedTable from '../List/NestedTable';
  import VueSweetalert2 from 'vue-sweetalert2';
  import swal from 'sweetalert2';
  window.Swal = swal;

  export default {
    name: 'ListReportsSection',

    components: {AlignMiddle,
      ListControl,
      NestedTable},

    props: {
      tableName: String,
      insightId: String,
      values: Array,
      active: Boolean,
      actionText:String,
      enableDownload: Boolean,
      enableAction: Boolean,
      enableSort: Boolean,
      defaultSortBy: String,
      defaultColumns: Array,
      allColumns: Array,
      enableFilter: Boolean,
      description: String
    },

     mixins: [
      InsightsComputationMixin
    ],

    watch: {
      values(v) {
        console.log(v);
      }
    },

    data() {
      console.log("all columns 1", Object.keys(this.values))
      console.log("all columns 2", this.allColumns)
      console.log("description", this.description)
      var allColumns = this.allColumns;

      var fields = [];
      allColumns.forEach(column => {
          fields.push({key: column, sortable: true})
        });
      return {
        totalRows: this.values.length,
        data_gotten: null,
        columns: [],
        description2: this.description,
        valueLabel: maybeMissingValueLabel,
        enableSort: true,
        enableFilter: true,
        fields: fields,
        perPage: 20,
        currentPage: 1,
        rowCount: 0,
        allColumns:allColumns,
        search: '',
        sortBy: null,
        sortOrder: 0,
        rowsPerPage: 20,

        isLoadingPage: false,
        activeDataPage: 0,
        startPosition: 0,
        titleCase
      }
    },
    created() {
      // this.readFromFakeMemory();
      this.doColumnsCleanup();
    },

    methods: {
      sortingChanged(e) {
        this.sortBy = e.sortBy;
        this.sortOrder = e.sortOrder;
      },

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        console.log('items', filteredItems)
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },

      checkArrayContainsObject(label){
       return Object.prototype.toString.call(label) === '[object Array]' && Object.prototype.toString.call(label[0]) === '[object Object]' ;
      },
      checkArrayContainsIDs(label){
       return Object.prototype.toString.call(label) === '[object Array]' && Object.prototype.toString.call(label[0]) != '[object Object]' ;
      },
      isObject(label){
       return Object.prototype.toString.call(label) == '[object Object]' ;
      },
      open_table(x=null){
        if (this.checkArrayContainsObject(x.value)){
            this.data_gotten = x.value;
        }
        else if (this.checkArrayContainsIDs(x.value)){
          this.data_gotten = x.value.map(name => ({list_items:name}));
        }
        else if(this.isObject(x.value)){
          this.data_gotten = [x.value];
        }
        this.table_key = (new Date()).getMilliseconds().toString();
        this.table_name = x.field.label;
      },
      resetInsightsData() {
        this.items = null;
        this.rowCount = 0;
      },

      makeSortParams() {
        const sort = parseInt(this.sortOrder);
        return this.enableSort ? {
          sort_by: this.sortBy,
          sort_asc: isNaN(sort) ? 0 : sort
        } : {};
      },
      makeFilterParams() {
        return this.enableFilter ? {
          search: this.search,
          search_on: this.columns
        } : {};
      },

       download() {
        this.$emit('download', {
          ...this.makeFilterParams(),
          ...this.makeSortParams()
        });
      },



            async act(record){
              const { value: email } = await Swal.fire({
                title: 'Enter email address',
                input: 'email',
                inputPlaceholder: 'Enter your email address'
              })

              if (email) {
               Swal.fire('Success', 'The email report has been sent', 'success')
               record['confirmed_email'] = email;


               this.$emit('act', record);
              }
            },
      async actAll(){
        let record = {}
              const { value: email } = await Swal.fire({
                title: 'Enter email address',
                input: 'email',
                inputPlaceholder: 'Enter your email address'
              })

              if (email) {
               Swal.fire('Success', 'The email report has been sent', 'success')
               record['confirmed_email'] = email;


               this.$emit('actAll', record);
              }
            },



      doColumnsCleanup() {
        const columns = this.allColumns;
        const exists = slug => !!columns.find(col => col.slug === slug);
        this.columns = this.columns.filter(exists);
        if (this.columns.length === 0) {
          this.columns =
            this.defaultColumns && this.defaultColumns.length > 0 ?
              [...this.defaultColumns] :
              columns.slice(0, 6)
                .map(col => col);
        }
        if (!this.sortBy || !exists(this.sortBy)) {
          this.sortBy = this.defaultSortBy || null;
        }
      },

      // sortingChanged(e) {
      //   this.sortBy = e.sortBy;
      //   this.sortOrder = e.sortOrder;
      // },

      // onFiltered(filteredItems) {
      //   // Trigger pagination to update the number of buttons/pages due to filtering
      //   console.log('items', filteredItems)
      //   this.totalRows = filteredItems.length;
      //   this.currentPage = 1;
      // },

      handleApply() {
        console.log("Sort by: ", this.sortBy);
        console.log("Sort by: ", this.sortOrder);
        this.compute(true);
      }
    },

    computed: {
      cookieKey() {
        return `_fake_mem_${this.insightId}_6`;
      },

      tableFields() {
        const colMap = {};
        this.allColumns.forEach(column => {
          colMap[column] = {key: column, label: column, sortable: false};
        });

        return this.columns.map(column => ({
          key: column,
          label: column,
          sortable: true,
        }));
      },

      sortByColumns() {
        return this.tableFields.map(
          ({key, label}) => ({value: key, text: label}));
      },

      rows() {
        return this.values.length;
      },

      style() {
        return {
          maxHeight: "100%",
          // height: "130%",
          overflowY: 'auto',
          borderRadius: 4
        };
      }
    }
  };
</script>

<style scoped>

</style>
